import { get } from 'lodash';

function isReferredToGroup(referral, groupId) {
  return groupId && groupId === get(referral, 'referred_to_group.id');
}

export default isReferredToGroup;
